export default __webpack_public_path__ + "static/media/ExpansionImg.9ba13a10.jpg";